import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, message } from 'antd';
import { Route, Switch } from 'react-router-dom';
import './style.css';
import List from '../../components/JobCardTable';
import Create from './create';
import {
  cancelJCWithDateAndRemark,
  clearProps,
  createResource,
  deleteResource,
  fetchResource,
  getResource,
  getResourceForDownload,
  saveResourceQuery,
  searchResource,
  unCancelledJobCard,
  updateJobCardWithDocument,
  updateResource,
} from '../../appRedux/actions/JobCard';

// import {fetchDetailsFromActivity} from '../../appRedux/actions/SubAssetTransfer';
import {
  fetchFilter, fetchMasterFilter, fetchPageSettingFilter,
  fetchReport,
  fetchVoucherByType,
  getComplaintData,
  getLocationByQuery, togglePageSettingVisible
} from '../../appRedux/actions';
import {
  fetchResourceByPage,
  updateResource as pageSettingUpdate,
} from '../../appRedux/actions/PageSetting';
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName
} from '../../util/methods';
import AccessControl from '../../components/AccessControl';
import Report from "./report";
import * as _ from 'lodash';
import JobCardList from "./list";
import JobCardUpload from "./upload";
import PageSettingPopUp from "../PageSetting/settingForm";
import JobCardCostingReport from "./costing-report";
import JobListCardView from "./report/card-view";

export class JobCard extends Component {
  initialQueryState = {
    sort: {
      field: '',
      order: '',
    },
    pagination: {
      pageSize: 10,
      current: 1,
    },
    filters: {
      status: '{"value":[["Open"]],"type":"String","field":"status"}'
    },
  };

  state = {
    fields: {
      name: {
        value: '',
      },
      description: {
        value: '',
      },
    },
    query: this.initialQueryState,
    columns: [],
    visibleColumns: [],
  };

  constructor(props) {
    super(props);
    const localStorageFilter = localStorage.getItem('filters');
    if (localStorageFilter) {
      this.initialQueryState.filters = JSON.parse(localStorageFilter);
    }
    props.saveResourceQuery(this.initialQueryState);
  }

  componentDidMount() {
    localStorage.removeItem('filters')
    this.props.fetchFilter(this.props.resourceName);
    //this.fetchList()
    // setTimeout(() => this.fetchList(), 500);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
      const columns = Object.keys(nextProps.filters).filter((filter) => Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
      const defaultCol = ['jobCardNo', 'assetCode', 'assetSubType', 'ownerCode', 'location', 'presentStatus', 'assetUnservicable', 'totalAmount'];
      this.setState({
        visibleColumns: [...defaultCol, ...columns],
      }, () => {
        this.renderColumns(nextProps.filters, this.state.visibleColumns);
      })
    }
  }

  handleColumnChange = (value, array) => {
    const { filters } = this.props;
    this.renderColumns(filters, value);
  };

  handleFilter = (selectedKeys, confirm, data) => {
    const query = { ...this.props.query };
    if (data.filterField === 'presentStatus') {
      query.filters[data.filterField] = JSON.stringify({
        value: selectedKeys,
        type: data.type,
        field: data.filterField,
      });
    }
    else if (data.filterField === 'presentStatusRemark') {
      query.filters[data.filterField] = JSON.stringify({
        value: selectedKeys,
        type: data.type,
        field: data.filterField,
      });
    }
    else {
      query.filters[data.field] = JSON.stringify({
        value: selectedKeys,
        type: data.type,
        field: data.field,
      });
    }
    localStorage.setItem('filters', JSON.stringify(query.filters));
    this.props.saveResourceQuery(query);
    confirm();
    // this.fetchList();
  };

  handleCustomFilter = (selectedKeys, confirm, data) => {
    const query = { ...this.props.query };
    query.filters[data.filterField] = JSON.stringify({
      value: selectedKeys,
      type: data.type,
      field: data.filterField,
    });
    localStorage.setItem('filters', JSON.stringify(query.filters));
    this.props.saveResourceQuery(query);
    confirm();
    //this.fetchList();
  };

  handleReset = (clearFilters, data) => {
    const query = { ...this.props.query };
    if (data && data.filterField && data.filterField === 'presentStatus') {
      delete query.filters[data.filterField];
    }
    else {
      delete query.filters[data.field];
    }
    localStorage.setItem('filters', JSON.stringify(query.filters));
    this.props.saveResourceQuery(query);
    clearFilters();
    // this.fetchList();
  };

  handleCustomReset = (clearFilters, data) => {
    const query = { ...this.props.query };
    delete query.filters[data.filterField];
    localStorage.setItem('filters', JSON.stringify(query.filters));
    this.props.saveResourceQuery(query);
    clearFilters();
    // this.fetchList();
  };

  // clearAll = () => {
  //   this.props.saveResourceQuery(this.initialQueryState);
  //   this.fetchList();
  // };

  clearAll = () => {
    const clearQueryState = {
      sort: {
        field: '',
        order: ''
      },
      pagination: {
        pageSize: 10,
        current: 1
      },
      filters: {
        status: '{"value":[["Open"]],"type":"String","field":"status"}'
      },
    };
    localStorage.setItem('filters', JSON.stringify(clearQueryState.filters));
    //this.props.saveResourceQuery(this.initialQueryState);
    this.props.saveResourceQuery(clearQueryState);
    this.fetchList();
    window.location.reload(false);
  };

  handleChange = (pagination, filters, sorter) => {
    const query = { ...this.props.query };
    query.pagination = { ...query.pagination, current: pagination.current };
    query.sort = sorter;

    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  handleFormChange = (changedFields) => {
    this.setState(({ fields }) => ({
      fields: { ...fields, ...changedFields },
    }));
  };

  linkHandler = (record, page, route) => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/report/${record._id}`);
  };

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];
    const { resourceName } = this.props;
    if (selectedColumns.indexOf('jobCardNo') >= 0) {
      columns.push({
        title: sanitizeFieldName('jobCardNo'),
        dataIndex: filters['jobCardNo'].field,
        sorter: true,
        ...getColumnSearchProps(filters['jobCardNo'], this.handleFilter, this.handleReset, resourceName),
        render: (value, record) => {
          getRenderForFieldByType(value, filters['jobCardNo'].type);
          return (
            <>
              <AccessControl resource={this.props.resourceName} permissionNeeded={'r'}
                roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                  return <>
                    {record && record.jobCardNo ? (
                      <Button className='button-for-job-card'
                        onClick={this.linkHandler.bind(this, record, 'jobcard', 'Open')}>{'' + (record && record.jobCardNo)}</Button>) :
                      <div>NA</div>
                    }
                  </>
                }} />
            </>
          );
        }
      });
    }
    if (selectedColumns.indexOf('assetCode') >= 0) {
      columns.push({
        title: 'Asset Code',
        dataIndex: 'assetCode',
        key: 'assetCode',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'String'),
        ...getColumnSearchProps({
          field: 'assetCode',
          type: 'String',
          filterField: 'assetCode'
        }, this.handleCustomFilter, this.handleCustomReset, 'Asset')
      });
    }
    if (selectedColumns.indexOf('ownerCode') >= 0) {
      columns.push({
        title: 'Owner Code',
        dataIndex: 'ownerCode',
        key: 'ownerCode',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'String'),
        ...getColumnSearchProps({
          field: 'ownerCode',
          type: 'String',
          filterField: 'ownerCode'
        }, this.handleCustomFilter, this.handleCustomReset, 'Asset')
      });
    }
    if (selectedColumns.indexOf('assetSubType') >= 0) {
      columns.push({
        title: 'Asset Sub Type',
        dataIndex: 'equipmentSubType',
        key: 'equipmentSubType',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'String'),
        ...getColumnSearchProps({
          field: 'name',
          type: 'String',
          filterField: 'assetSubType'
        }, this.handleCustomFilter, this.handleCustomReset, 'EquipmentSubType'),
      });
    }
    if (selectedColumns.indexOf('location') >= 0) {
      columns.push({
        title: 'Location',
        dataIndex: 'location',
        key: 'location',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'String'),
        ...getColumnSearchProps({
          field: 'name',
          type: 'String',
          filterField: 'location'
        }, this.handleCustomFilter, this.handleCustomReset, 'Location'),
      });
    }
    if (selectedColumns.indexOf('status') >= 0) {
      columns.push({
        title: sanitizeFieldName('status'),
        dataIndex: filters['status'].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters['status'].type),
        ...getColumnSearchProps(filters['status'], this.handleFilter, this.handleReset, resourceName),
      });
    }

    if (selectedColumns.indexOf('statusTitle') >= 0) {
      columns.push({
        title: sanitizeFieldName('Pending Invoice'),
        dataIndex: filters['statusTitle'].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters['statusTitle'].type, 'jobCard.statusTitle'),
        ...getColumnSearchProps(filters['statusTitle'], this.handleFilter, this.handleReset, resourceName),
      });
    }
    if (selectedColumns.indexOf('expectedDateOfCompletion') >= 0) {
      columns.push({
        title: sanitizeFieldName('expectedDateOfCompletion'),
        dataIndex: filters['expectedDateOfCompletion'].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters['expectedDateOfCompletion'].type),
        ...getColumnSearchProps(filters['expectedDateOfCompletion'], this.handleFilter, this.handleReset, resourceName),
      });
    }
    if (selectedColumns.indexOf('presentStatus') >= 0) {
      columns.push({
        title: sanitizeFieldName('presentStatus'),
        dataIndex: 'presentStatus',
        key: 'presentStatus',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'String', 'jobCard.presentStatus'),
        ...getColumnSearchProps({
          field: 'status',
          type: 'String',
          filterField: 'presentStatus'
        }, this.handleFilter, this.handleReset, resourceName),
      });
    }
    if (selectedColumns.indexOf('presentStatusRemark') >= 0) {
      columns.push({
        title: sanitizeFieldName('presentStatusRemark'),
        dataIndex: 'presentStatusRemark',
        key: 'presentStatusRemark',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'String'),
        ...getColumnSearchProps({
          field: 'presentStatusRemark',
          type: 'String',
          filterField: 'presentStatusRemark',
          showFilter: false,
        }, this.handleFilter, this.handleReset, resourceName),
      });
    }
    if (selectedColumns.indexOf('assetUnservicable') >= 0) {
      columns.push({
        title: 'Unserviceable',
        dataIndex: 'assetUnservicable',
        key: 'assetUnservicable',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'Boolean'),
      });
    }
    if (selectedColumns.indexOf('detailsOfComplaint') >= 0) {
      columns.push({
        title: sanitizeFieldName('detailsOfComplaint'),
        dataIndex: 'detailsOfComplaint',
        key: 'detailsOfComplaint',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'String'),
      });
    }
    if (selectedColumns.indexOf('causeOfDamage') >= 0) {
      columns.push({
        title: sanitizeFieldName('causeOfDamage'),
        dataIndex: 'causeOfDamage',
        key: 'causeOfDamage',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'String'),
      });
    }
    if (selectedColumns.indexOf('client') >= 0) {
      columns.push({
        title: 'Sub Location',
        dataIndex: 'client',
        key: 'client',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'String'),
        ...getColumnSearchProps({
          field: 'name',
          type: 'String',
          filterField: 'client'
        }, this.handleCustomFilter, this.handleCustomReset, 'Client'),
      });
    }
    if (selectedColumns.indexOf('complaintDate') >= 0) {
      columns.push({
        title: 'Complaint Date',
        dataIndex: 'complaintDate',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'Date'),
        ...getColumnSearchProps({
          field: 'complaintDate',
          type: 'Date',
          filterField: 'complaintDate'
        }, this.handleCustomFilter, this.handleCustomReset, 'Complaint'),
      });
    }
    if (selectedColumns.indexOf('owner') >= 0) {
      columns.push({
        title: 'Owner',
        dataIndex: 'owner',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'String'),
        ...getColumnSearchProps({
          field: 'name',
          type: 'String',
          filterField: 'owner'
        }, this.handleCustomFilter, this.handleCustomReset, 'Owner'),
      });
    }
    if (selectedColumns.indexOf('assetType') >= 0) {
      columns.push({
        title: 'Asset Type',
        dataIndex: 'assetType',
        key: 'assetType',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'String'),
        ...getColumnSearchProps({
          field: 'name',
          type: 'String',
          filterField: 'assetType'
        }, this.handleCustomFilter, this.handleCustomReset, 'AssetType'),
      });
    }
    Object.keys(filters).forEach((item) => {
      if (selectedColumns.indexOf(item) === -1 || item === 'statusTitle' || item === 'jobCardNo' || item === 'status' || item === 'expectedDateOfCompletion' || item === 'location' || item === 'client') {
        return;
      }
      columns.push({
        title: sanitizeFieldName(item),
        dataIndex: filters[item].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters[item].type, item),
        ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName),
      });
    });
    if (selectedColumns.indexOf('lastStatusUpdate') >= 0) {
      columns.push({
        title: sanitizeFieldName('lastStatusUpdate'),
        dataIndex: 'lastStatusUpdate',
        key: 'lastStatusUpdate',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'Date'),
      });
    }
    if (selectedColumns.indexOf('activitiesAmount') >= 0) {
      columns.push({
        title: 'Activities Amount',
        dataIndex: 'activitiesAmount',
        key: 'activitiesAmount',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'Number'),
      });
    }

    if (selectedColumns.indexOf('sparesAmount') >= 0) {
      columns.push({
        title: 'Spares Amount',
        dataIndex: 'sparesAmount',
        key: 'sparesAmount',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'Number'),
      });
    }
    if (selectedColumns.indexOf('totalAmount') >= 0) {
      columns.push({
        title: 'Total Amount',
        dataIndex: 'totalAmount',
        key: 'totalAmount',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'Number'),
      });
    }

    this.setState({
      visibleColumns: selectedColumns,
      columns,
    });
  };

  fetchList = () => {
    this.props.getResource();
  };

  createResource = (values, source) => {
    // let params = new URLSearchParams( window.location.search);
    // let source = params.get('source');
    this.props.createResource(values, source);
  };

  updateResource = (values, id) => {
    this.props.updateResource(values, id);
  };

  deleteResource = (id) => {
    this.props.deleteResource(id);
  };

  cancelDelete = () => {
    message.error('Cancelled');
  };

  create = () => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/add`);
  };

  edit = (id) => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/edit/${id}`);
  };

  editFromReport = (id) => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/edit/${id}`);
  };

  cancelJobCard = (id, data) => {
    this.props.cancelJCWithDateAndRemark(id, data);
  }

  // uncancelledJobCardFunction=(id, data)=>{
  //   this.props.uncancelledJobCard(id, data);
  // }

  updateJobCardWithDocumentFunction = (id, data) => {
    this.props.updateJobCardWithDocument(id, data)
  }

  deleteFromReport = (id) => {
    this.props.deleteResource(id);
    const { match } = this.props;
    this.props.history.push(`${match.url}`);
  };

  downloadToCSV = () => {
    const columns = [];
    // console.log('this.state.columns:', this.state.columns)
    this.state.columns.map(column => column.title !== "Action" && columns.push(_.camelCase(column.title)));
    columns.push('statusTitle');
    columns.push('assetUnservicable');
    this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, this.state.columns, "JobCard");
  }

  report = (id) => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/report/${id}`);
  };

  getLocationByQuery = (location) => {
    this.props.getLocationByQuery(location);
  };

  getComplaintData = (e) => {
    this.props.getComplaintData(e);
  };

  goBackOnTableWithOriginalFilter = (orignalQuery) => {
    this.props.saveResourceQuery(orignalQuery);
  };

  clickVoucherNo = (type, no) => {
    this.props.fetchVoucherByType(type, no);
  };

  render() {
    const { match, data, resource, edit, fetchResource, fetchReport, loading, filters, modules, authUser, resourceName, allLocation, complaint, report, downloadProgress } = this.props;

    const { columns, visibleColumns } = this.state;
    faviconDynamicFunction(authUser);
    return (<div>
      {/* <h2>{sanitizeFieldName(resourceName)}</h2> */}
      <Switch>
        {/* <Route path={`${match.url}`} exact
          render={() => <List columns={columns}
            visibleColumn={visibleColumns}
            data={data}
            clearFilter={this.clearAll}
            filters={filters}
            handleChange={this.handleChange}
            columnChange={this.handleColumnChange}
            downloadToCSV={this.downloadToCSV}
            title={resourceName}
            size={'middle'}
            create={this.create}
            downloadProgress={downloadProgress}
            pagination={this.props.query.pagination}
            loading={loading}
            authUser={authUser}
            fetchList={this.fetchList}
          />
          } /> */}
        <Route path={`${match.url}`} exact
          render={(props) => <JobListCardView resourceName={`JobCard/CardView`} authUser={authUser} {...props} />
          } />

        <Route path={`${match.url}/search`}
          render={(props) => <JobCardList resourceName={`JobCard/Search`} {...props} />
          } />
        <Route path={`${match.url}/upload`}
          render={(props) => <JobCardUpload resourceName={`JobCard/Upload`} {...props} />
          } />
        <Route path={`${match.url}/add`}
          render={(props) => <Create data={{}}
            filters={filters}
            modules={modules}
            title={'CREATE'}
            resource={resourceName}
            onChange={this.handleFormChange}
            onSubmit={this.createResource}
            allLocation={allLocation}
            complaint={complaint}
            clearProps={this.props.clearProps}
            getComplaintData={this.getComplaintData}
            getLocationByQuery={this.getLocationByQuery}
            loading={loading}
            authUser={authUser}

            // togglePageSettingVisible={this.props.togglePageSettingVisible}
            // pageSettingVisible={this.props.pageSettingVisible}

            // fetchResourceByPage={this.props.fetchResourceByPage}
            // pageSettingData={this.props.pageSettingData}
            // fetchPageWiseFields={this.props.fetchMasterFilter}
            // pageWiseFields={this.props.pageWiseFields}
            // fetchPageSettingFilter={this.props.fetchPageSettingFilter}
            // pageSettingFilters={this.props.pageSettingFilters}
            // updatePageSetting={this.props.pageSettingUpdate}
            {...props}
          />
          } />
        <Route path={`${match.url}/edit/:id`}
          render={(props) => <Create data={edit}
            filters={filters}
            modules={modules}
            title={'EDIT'}
            allLocation={allLocation}
            resource={resourceName}
            fetch={fetchResource}
            complaint={complaint}
            clearProps={this.props.clearProps}
            onChange={this.handleFormChange}
            onSubmit={this.updateResource}
            getComplaintData={this.getComplaintData}
            getLocationByQuery={this.getLocationByQuery}
            loading={loading}
            authUser={authUser}
            // togglePageSettingVisible={this.props.togglePageSettingVisible}
            // pageSettingVisible={this.props.pageSettingVisible}
            {...props}
          />
          } />

        <Route path={`${match.url}/report/:id`}
          render={(props) => <Report data={report}
            filters={filters}
            modules={modules}
            title={'REPORT'}
            allLocation={allLocation}
            resource={resourceName}
            authUser={authUser}
            fetch={fetchReport}
            complaint={complaint}
            editFromReportButton={this.editFromReport}
            deleteFromReportButton={this.deleteFromReport}
            clearProps={this.props.clearProps}
            getComplaintData={this.getComplaintData}
            cancelJCRemark={this.cancelJobCard}
            // uncancelledJobCard={this.uncancelledJobCardFunction}
            unCancelledJobCard={this.props.unCancelledJobCard}
            getLocationByQuery={this.getLocationByQuery}
            initialQuery={this.initialQueryState}
            goBackFunctionForTable={this.goBackOnTableWithOriginalFilter}
            updateJobCardWithDocument={this.updateJobCardWithDocumentFunction}
            loading={loading}
            clickVoucherNo={this.clickVoucherNo}
            // fetchDetailsFromActivity={this.props.fetchDetailsFromActivity}
            // satDetail={this.props.satDetail}
            // satDetailsLoading={this.props.satDetailsLoading}
            {...props}
          />
          } />
        <Route path={`${match.url}/costing-report`}
          render={(props) => <JobCardCostingReport
            filters={filters}
            modules={modules}
            authUser={authUser}
            loading={loading}
            {...props}
          />
          } />
      </Switch>
    </div>);
  }
}

const mapStateToProps = ({ auth, jobCard, commonData, subAssetTransfer, pageSetting }) => {
  return {
    authUser: auth.authUser,
    total: jobCard.total,
    data: jobCard.resources,
    resource: jobCard.resource,
    edit: jobCard.edit,
    query: jobCard.query,
    allLocation: jobCard.location,
    complaint: jobCard.complaint,
    loading: commonData.loading,
    filters: commonData.filters,
    modules: commonData.modules,
    report: jobCard.report,
    downloadProgress: commonData.download,
    // successObject: jobCard.resource,
    // satDetail: subAssetTransfer.resource,
    // satDetailsLoading: subAssetTransfer.isStartFromActivity,

    // pageSettingVisible: commonData.pageSettingVisible,
    // pageSettingFilters: commonData.pageSettingFilters, /*(fetchPageSettingFilter)*/
    // pageSettingData: pageSetting.pageSettings, /*fetchResourceByPage*/
    // // pageSettingData: pageSetting.edit,
    // pageWiseFields: commonData.masterFilters,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    getResource,
    getResourceForDownload,
    createResource,
    fetchResource,
    updateResource,
    deleteResource,
    saveResourceQuery,
    fetchFilter,
    getLocationByQuery,
    getComplaintData,
    fetchReport,
    clearProps,
    cancelJCWithDateAndRemark,
    unCancelledJobCard,
    updateJobCardWithDocument,
    // fetchDetailsFromActivity
    searchResource,
    fetchVoucherByType,

    // togglePageSettingVisible,
    // fetchMasterFilter,
    // fetchPageSettingFilter,
    // fetchResourceByPage,
    // pageSettingUpdate
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(JobCard);
